module.exports = __webpack_public_path__ + "img/open-aside.753d40a5.svg";